import { Box as ChakraBox } from '@chakra-ui/layout';

export const Box = ChakraBox;
